<p-table #dt styleClass="p-datatable-responsive-demo" [value]="venueSvc.ooPromoCodes" [globalFilterFields]="app.keys(venueSvc.ooPromoCodes)">
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<span class="p-float-label p-input-icon-left m-2 flex-grow-1">
				<i class="pi pi-search"></i>
				<input
					pInputText
					class="w-100"
					id="globalSearch"
					name="globalSearch"
					style="width: 100%"
					type="text"
					(input)="dt.filterGlobal($event.target.value, 'contains')"
				/>
				<label for="globalSearch">Search...</label>
			</span>
			<p-button pRipple styleClass="p-button-raised p-button-primary m-2" (click)="onCreateNew()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1 me-2"></fa-icon>
						New PromoCode
					</div>
				</ng-template>
			</p-button>
		</div>
	</ng-template>
	<ng-template pTemplate="header" #header>
		<tr>
			<th>Code</th>
			<th>Active</th>
			<th>Type</th>
			<th>Value</th>
			<th>POS Item</th>
			<th>Available on</th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" #body let-rec let-idx="rowIndex">
		<tr (click)="promoCodeSelectedChange.emit(rec)">
			<td>
				<span class="p-column-title">Code</span>
				{{ rec.promoCode }}
			</td>
			<td>
				<span class="p-column-title">Active</span>
				<fa-icon *ngIf="rec.active" [icon]="['far', 'check']"></fa-icon>
			</td>
			<td class="">
				<span class="p-column-title">Type</span>
				<div class="d-flex flex-column">
					<div *ngIf="rec.types?.includes(1)"><fa-icon [icon]="['far', 'mobile']" class="ms-1"></fa-icon> MobilePay</div>
					<div *ngIf="rec.types?.includes(2)"><fa-icon [icon]="['far', 'shopping-cart']" class="ms-1"></fa-icon> OO</div>
					<div *ngIf="rec.types?.includes(3)"><fa-icon [icon]="['far', 'gift-card']" class="ms-1"></fa-icon> eGift</div>
					<div *ngIf="rec.types?.includes(4)"><fa-icon [icon]="['far', 'tablet-screen']" class="ms-1"></fa-icon> Kiosk</div>
				</div>
			</td>
			<td>
				<span class="p-column-title">Value</span>
				{{ rec.value | currency }}
			</td>
			<td>
				<span class="p-column-title">POS Item</span>
				{{ rec.menuItem?.name }}
			</td>
			<td>
				<span class="p-column-title">Available on</span>
				<div class="d-flex flex-wrap justify-content-end">
					<div *ngFor="let day of rec.availableDays" class="me-1">
						{{ app.moment(day, "d").format("ddd") }}
					</div>
				</div>
			</td>
		</tr>
	</ng-template>
</p-table>
